export const apiURL = 'http://www.tonex.su/demo2/api/';
export const CORSSupport = 'https://cors-anywhere.herokuapp.com/';
export const userID= 72;
export const userLogin = 'заказчикТЕСТ1';
export const userPassword ='987654321';
export const contractId = 1;
export const action_user = 'user';
export const action_order = 'order';
export const action_order_list = 'order.list';
export const action_catalog = 'catalog';
export const action_catalog_list = 'catalog.list';
export const action_login = 'login';
export const action_order_create = 'order.create';
export const phone_number = {text: '8 (800) 222-91-93', number: '+78002229193'};
export const mail = 'info@tonex.ru';
